"use strict";

var __importDefault = function (e) {
  return e && e.__esModule ? e : {
    default: e
  };
},
    react_1 = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DotsNavigation = void 0, __importDefault(require("react"))),
    types_1 = require("../types"),
    utils_1 = require("../utils");

exports.DotsNavigation = function (e) {
  var o = e.state,
      n = e.onClick,
      r = e.onMouseEnter,
      l = e.onMouseLeave,
      t = e.controlsStrategy,
      u = e.renderDotsItem,
      c = o.itemsCount,
      _ = o.itemsInSlide,
      d = o.infinite,
      e = o.autoWidth,
      m = o.activeIndex,
      f = utils_1.getSlideItemInfo(o).isNextSlideDisabled,
      v = utils_1.hasDotForEachSlide(e, t),
      p = utils_1.getDotsNavigationLength(c, _, v);
  return react_1.default.createElement("ul", {
    className: types_1.Classnames.DOTS
  }, Array.from({
    length: c
  }).map(function (e, t) {
    var i, s, a;
    if (t < p) return s = utils_1.checkIsTheLastDotIndex(t, Boolean(d), p), i = utils_1.getItemIndexForDotNavigation(t, s, c, _), s = utils_1.getActiveSlideIndex(f, o), v && ((s = m) < 0 ? s = c - 1 : c <= m && (s = 0), i = t), s = s === t ? types_1.Modifiers.ACTIVE : "", a = u ? types_1.Modifiers.CUSTOM : "", a = utils_1.concatClassnames(types_1.Classnames.DOTS_ITEM, s, a), react_1.default.createElement("li", {
      key: "dot-item-" + t,
      onMouseEnter: r,
      onMouseLeave: l,
      onClick: function () {
        return n(i);
      },
      className: a
    }, u && u({
      isActive: s,
      activeIndex: t
    }));
  }));
};